/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compass_DeniedInputs */



/**
* | output |
* | --- |
* | "Access to the compass was denied" |
*
* @param {Compass_DeniedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const compass_denied = /** @type {((inputs?: Compass_DeniedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compass_DeniedInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Access to the compass was denied")
	return /** @type {LocalizedString} */ ("L'accès à la boussole a été refusé")
});